import { Injectable } from '@angular/core';
import { isEmptyString } from 'foundation';

@Injectable({
  providedIn: 'root'
})
export class PosUtilService {

  constructor() {
  }

  emptyString(str: any): boolean {
    return isEmptyString(str);
  }
}
